import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className=' flex my-20'>
      <div className=' mx-auto w-[50vw]'>
    
      <div className=' text-justify'><div className="max-w-5xl mx-auto p-8 text-gray-700 leading-relaxed">
  <h1 className="text-4xl font-bold text-center mb-10">Privacy Policy</h1>

  <p><strong>Effective Date:</strong> 26 - 4 - 2025</p>

  <p>Welcome to <strong>Growmore</strong>!</p>

  <p>At Growmore, we value your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.</p>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Information We Collect</h2>
  <ul className="list-disc ml-6 space-y-2">
    <li><strong>Personal Information:</strong> Name, email address, phone number (when you submit forms or contact us).</li>
    <li><strong>Usage Data:</strong> IP address, browser type, device information, and browsing behavior.</li>
    <li><strong>Cookies:</strong> We use cookies to enhance your experience and understand how you interact with our site.</li>
  </ul>

  <h2 className="text-2xl font-semibold mt-8 mb-4">How We Use Your Information</h2>
  <ul className="list-disc ml-6 space-y-2">
    <li>To provide and improve our services</li>
    <li>To personalize your experience</li>
    <li>To send updates, promotions, and support messages</li>
    <li>To maintain security and prevent fraud</li>
  </ul>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Sharing Your Information</h2>
  <p>We only share your information with trusted service providers, to comply with legal obligations, or to protect our rights and security. We do <strong>not</strong> sell your personal data.</p>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Your Choices</h2>
  <ul className="list-disc ml-6 space-y-2">
    <li>Access, update, or delete your personal information</li>
    <li>Opt-out of marketing emails</li>
    <li>Disable cookies through browser settings</li>
  </ul>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Data Security</h2>
  <p>We implement reasonable security measures to protect your information. However, no method of transmission over the Internet is 100% secure.</p>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Third-Party Links</h2>
  <p>Our website may contain links to third-party sites. We are not responsible for their privacy practices.</p>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Changes to This Policy</h2>
  <p>We may update this Privacy Policy from time to time. Updates will be posted here with an updated effective date.</p>

  <h2 className="text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
  <p>If you have any questions, please contact us at: <strong>info@growmoreweb.com</strong></p>
</div>
</div>
      </div>
    </div>
  )
}

export default PrivacyPolicy